import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-help-centers',
  templateUrl: './help-centers.component.html'
})
export class HelpCentersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
